import { POST } from './api-handler.service';
import { HELP_SUPPORT_SUBMIT } from '../constants/url.constants';
import {
    getAuthenticationHeaders,
    getBaseUrl,
    isUserLoggedIn,
    setAuthHeadersFromKey,
} from '../auth/auth-helper';

export interface HelpSupportPayload {
    name: string;
    email: string;
    phone: string;
    query: string;
}

/**
 * Pre-login open API for /help-support. Decodes the `key` query param into
 * localStorage so organisation-id and base-url come along, then sends the
 * standard auth headers. skipGenericErrors keeps a stale 401 from kicking
 * the rider to /session-expired mid-form.
 *
 * Throws when the `key` param is missing/malformed AND no rider is already
 * logged in — the caller surfaces this to the user.
 */
export async function submitHelpSupportQuery(body: HelpSupportPayload) {
    try {
        setAuthHeadersFromKey();
    } catch (e) {
        if (!isUserLoggedIn()) throw e;
    }

    const url = `${getBaseUrl()}${HELP_SUPPORT_SUBMIT}`;
    return POST(url, body, getAuthenticationHeaders(), undefined, true);
}
